<!-- <a matTooltip="{{this.translate.data['TOOLTIPVIEWUSERPERMISSION'] | translate}}" (click)="openGroupRoleClaimsDialog()">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_list}}</mat-icon>
</a> -->
<!-- <a matTooltip="{{this.translate.data['TOOLTIPVIEWPROJECTUSERS'] | translate}}" (click)="openViewUsersDialog()">
    <mat-icon aria-hidden="false" aria-label="icon">person</mat-icon>
</a>
<a matTooltip="{{this.translate.data['TOOLTIPADDUSER'] | translate}}" (click)="openUserGroupRoleDialog()">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_person}}</mat-icon>
</a>
<a matTooltip="{{this.translate.data['TOOLTIPDELETEGROUPROLE'] | translate}}" (click)="openGroupRoleDeleteDialog()" matBadge="{{numberOfUser}}" matBadgeSize="small">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_delete}}</mat-icon>
</a> -->

<a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPVIEWUSERPERMISSION'] | translate}}" (click)="openGroupRoleClaimsDialog()">Berechtigungen</button>
</a>
<a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPVIEWPROJECTUSERS'] | translate}}" (click)="openViewUsersDialog()">Benutzer</button>
</a>
<a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPADDUSER'] | translate}}" (click)="openUserGroupRoleDialog()">Neuer Benutzer</button>
</a>
<a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPDELETEGROUPROLE'] | translate}}" (click)="openGroupRoleDeleteDialog()">Löschen</button>
</a>
